import { all, call, put, select, takeLatest } from 'typed-redux-saga/macro';

import { actions } from './slice';
import { DATA_FETCHING_STATUS } from '../../constants';
import BackendService from 'src/services/BackendService';
import {
  actionSuccessNotification,
  notifyUserByActionTypeAndCode,
} from 'src/utils/errorHandling/notifications';
import { getState as getOperatorsState } from 'src/redux/data/operators/modules/slice';
import { parseEmrSchedullingFrequencyPayload } from './utils';

function* getEmrSchedullingFrequncyByOperatorId(
  action: ReturnType<typeof actions.getEmrSchedullingFrequncyByOperatorId>,
) {
  const { currentOperator } = yield* select(getOperatorsState);

  const operatorId = currentOperator?.id || '';
  const emrType =
    (currentOperator?.emrMappings &&
      currentOperator?.emrMappings[0]?.apiProvider?.emrType) ||
    '';

  try {
    yield* put(
      actions.setGetEmrSchedullingFrequncyStatus(DATA_FETCHING_STATUS.LOADING),
    );

    const { data } = yield* call(
      BackendService.getEmrSchedullingFrequncyByOperatorId,
      operatorId,
      emrType,
    );

    yield* put(actions.setEmrSchedullingFrequncy(data));
    yield* put(
      actions.setGetEmrSchedullingFrequncyStatus(DATA_FETCHING_STATUS.SUCCESS),
    );
  } catch (e) {
    console.error('error in fetchEmrSchedullingFrequnecy: ', e);
    yield* put(
      actions.setGetEmrSchedullingFrequncyStatus(DATA_FETCHING_STATUS.ERROR),
    );
    notifyUserByActionTypeAndCode(action.type, e, e);
  }
}

function* createEmrSchedullingFrequncyByOperatorId(
  action: ReturnType<typeof actions.createEmrSchedullingFrequncyByOperatorId>,
) {
  const { currentOperator } = yield* select(getOperatorsState);

  const data = action.payload;

  const emrType =
    (currentOperator?.emrMappings &&
      currentOperator?.emrMappings[0]?.apiProvider?.emrType) ||
    '';

  const emrSchedullingFrequencyPayload = {
    emrType,
    operatorId: currentOperator?.id,
    ...parseEmrSchedullingFrequencyPayload(data),
  };

  try {
    yield* put(
      actions.setEmrSchedullingFrequncyStatus(DATA_FETCHING_STATUS.LOADING),
    );
    yield* call(
      BackendService.createEmrSchedullingFrequncyByOperatorId,
      emrSchedullingFrequencyPayload,
    );
    yield* put(
      actions.setEmrSchedullingFrequncyStatus(DATA_FETCHING_STATUS.SUCCESS),
    );
    yield* put(actions.getEmrSchedullingFrequncyByOperatorId());
    actionSuccessNotification(action.type);
  } catch (e) {
    console.error('error in create shcedulling: ', e);
    yield* put(
      actions.setEmrSchedullingFrequncyStatus(DATA_FETCHING_STATUS.ERROR),
    );
    notifyUserByActionTypeAndCode(action.type, null, e);
  }
}

function* editEmrSchedullingFrequncyByOperatorId(
  action: ReturnType<typeof actions.editEmrSchedullingFrequncyByOperatorId>,
) {
  const { currentOperator } = yield* select(getOperatorsState);

  const data = action.payload;

  const operatorId = currentOperator?.id || '';

  const emrType =
    (currentOperator?.emrMappings &&
      currentOperator?.emrMappings[0]?.apiProvider?.emrType) ||
    '';

  try {
    yield* put(
      actions.setEmrSchedullingFrequncyStatus(DATA_FETCHING_STATUS.LOADING),
    );
    yield* call(BackendService.editEmrSchedullingFrequncyByOperatorId, {
      operatorId,
      emrType,
      data,
    });
    yield* put(
      actions.setEmrSchedullingFrequncyStatus(DATA_FETCHING_STATUS.SUCCESS),
    );
  } catch (e) {
    console.error('error in edit shcedulling: ', e);
    yield* put(
      actions.setEmrSchedullingFrequncyStatus(DATA_FETCHING_STATUS.ERROR),
    );
    notifyUserByActionTypeAndCode();
  }
}

export default function* watchEmrSchedullingFrequencyActions() {
  yield* all([
    takeLatest(
      actions.getEmrSchedullingFrequncyByOperatorId,
      getEmrSchedullingFrequncyByOperatorId,
    ),
    takeLatest(
      actions.createEmrSchedullingFrequncyByOperatorId,
      createEmrSchedullingFrequncyByOperatorId,
    ),
    takeLatest(
      actions.editEmrSchedullingFrequncyByOperatorId,
      editEmrSchedullingFrequncyByOperatorId,
    ),
  ]);
}
